import type { NavigationGuard } from 'vue-router'
import type { IErrorResponse } from '@/shared/interfaces/error-response.interface'
import { EPage } from '@/shared/enum/page.enum'
import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'
import { EResponseStatus } from '@/shared/enum/response-status.enum'
import { useToken } from '@/shared/composables/useToken'
import { fetchProfileUserBuyPackage } from '@/api/eiko-profile'
import { useTokenSwitcher } from '@/shared/composables/useTokenSwitcher'
import { setErrorInLocalStorage } from '@/shared/utils/errors'
import type { IApiError } from '@/shared/interfaces/api-error.interface'

export const profiledUserGuard: NavigationGuard = async (_to, _from, next) => {
  const { isProfiledToken } = useToken()
  const { setValueToken } = useTokenSwitcher()

  if (isProfiledToken.value) return next()

  try {
    const token = await fetchProfileUserBuyPackage()
    setValueToken(token)
  } catch (error) {
    const e = error as IApiError
    const errorResponse: IErrorResponse = {
      code: e.code,
      message: e.message,
      status: e.status,
      data: e.data
    }
    setErrorInLocalStorage(errorResponse)
    const routeByStatus: Record<number, EPage> = {
      [EResponseStatus.LATE_PAYMENT]: EPage.LATE_PAYMENT,
      [EResponseStatus.AUTH_RULES]: EPage.BUY_RECHARGES
    }
    const redirectRoute = routeByStatus[e.status] ?? EPage.GENERIC_ERROR

    return next({ name: redirectRoute })
  }
  next()
}
